import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { Link, Image, Text, mergeStyleSets, Stack } from '@fluentui/react';
import { getEmptyRatingSummary } from './ratingSummary';
import redirectLogo from '@shared/images/Redirect.svg';
import { launchTelemetry } from '@shared/utils/reviewsUtils';
import { Constants } from '@shared/utils/constants';
import { logger } from '@src/logger';
import * as PropTypes from 'prop-types';
export function getExternalProductLink(productName) {
    return productName ? `https://www.g2.com/products/${productName}/reviews` : '';
}
const contentStyles = mergeStyleSets({
    externalRatingSummariesTitle: {
        fontSize: 16,
        lineHeight: 22,
        fontWeight: 600
    },
    externalRatingSourceImage: {
        width: 16,
        height: 16,
        marginTop: 3,
        marginRight: 10
    },
    externalSummaryUrlImage: {
        height: 13,
        width: 13,
        marginBottom: 1
    }
});
export const ExternalRatingSummary = ({ ratingSummary = getEmptyRatingSummary(), image = '', showImage = true, source }, context)=>{
    ratingSummary = ratingSummary || getEmptyRatingSummary();
    return /*#__PURE__*/ _jsxs("div", {
        className: "externalRatingSummaryContainer",
        children: [
            showImage && /*#__PURE__*/ _jsx("div", {
                className: contentStyles.externalRatingSourceImage,
                children: /*#__PURE__*/ _jsx(Image, {
                    src: image,
                    className: "externalRatingSummaryImage",
                    alt: context.loc('External_Rating_Summary_Image_Alt', 'Rating summary image')
                })
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                horizontal: true,
                tokens: {
                    childrenGap: 8
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: contentStyles.externalRatingSummariesTitle,
                        children: context.loc(`ExternalRatingSummaries_${source}_Title`, `${source} ratings`)
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "externalRatingSummaryRightContainer",
                        children: /*#__PURE__*/ _jsx(Link, {
                            className: "externalSummaryUrl",
                            href: getExternalProductLink(ratingSummary.ExternalOfferReference),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            onClick: ()=>{
                                launchTelemetry(Constants.Telemetry.Action.Click, Constants.Telemetry.ActionModifier.ExternalRatingSummaryLink, {
                                    source: ratingSummary.Source
                                });
                                logger.info(JSON.stringify({
                                    source: ratingSummary.Source
                                }), {
                                    action: Constants.Telemetry.Action.Click,
                                    actionModifier: Constants.Telemetry.ActionModifier.ExternalRatingSummaryLink
                                });
                            },
                            children: /*#__PURE__*/ _jsx(Image, {
                                src: redirectLogo,
                                className: contentStyles.externalSummaryUrlImage,
                                alt: context.loc('ExternalRatingSummaries_External_Summary_Logo_Alt', 'External rating provider logo')
                            })
                        })
                    })
                ]
            })
        ]
    }, `externalRatingSummaryContainer${ratingSummary.Source}`);
};
ExternalRatingSummary.contextTypes = {
    loc: PropTypes.func
};
